<template>
  <znl-dialog
    :visible="visible"
    :append-to-body="true"
    width="300px"
    :height="360"
    @close="$emit('update:visible', false)"
    class="c-SetProductName"
  >
    <div>
      <textarea
        v-model="str"
        placeholder="请输入型号、品名，如：
LM358 PName
BAV99 PName1"
      >

      </textarea>
    </div>
    <div slot="footer">
      <znl-button
        :width="80"
        :height="30"
        @click="$emit('update:visible', false)"
      >取消</znl-button>
      <znl-button
        :width="80"
        :height="30"
        style-type="main"
        @click="matchStr"
      >确定</znl-button>
    </div>
  </znl-dialog>
</template>
<script>
export default {
  name: 'SetProductName',
  props: {
    visible: Boolean
  },
  data() {
    return {
      str: ''
    };
  },
  methods: {
    matchStr() {
      const rows = this.str.split('\n');
      const datas = [];
      rows.forEach(item => {
        datas.push({
          Model: item.split(/\s+/)[0],
          ProductName: item.split(/\s+/)[1]
        });
      });
      this.$emit('matchStr', datas);
      this.$emit('update:visible', false);
    }
  }
};
</script>
<style lang="scss">
.c-SetProductName {
  .znl-button {
    margin-left: 10px;
  }
  textarea {
    resize: none;
    width: 100%;
    height: 300px;
    line-height: 24px;
    padding: 0 0 0 5px;
    margin: 0;
    outline: none;
    border: 1px solid #ccc;
    box-sizing: border-box;
  }
}
</style>